<template>
  <div>
      <section class="section is-medium">
    <div class="container">
      
      
      <div class="columns is-centered">
        <div class="column is-8">
          <div class="content is-medium">
 <h1 class="title">Your Newsletter Rocks!</h1>
              <h2 class="subtitle">Get the Feedback It Deserves!</h2>

                <p>Hey,</p>

                <p>
                  My name is Jens, and I created FeedLetter out of my own need.
                </p>

                <p>
                  I currently run 2 newsletters and a few more in the past. One
                  of the common problems I had was getting feedback from my
                  readers.
                </p>

                <p>
                  <strong
                    >So, I tried a couple of things but mostly crickets.</strong
                  >
                </p>

                <ul>
                  <li>
                    Asking open questions in the emails so readers could reply
                  </li>
                  <li>Asking for feedback, their opinion, what they think</li>
                  <li>Explicitly stating in the emails to REPLY</li>
                  <li>Using incentives for replying</li>
                  <li>Linking to a survey using Typeform</li>
                  <li>Using the survey tool my mail provider offers</li>
                </ul>

                <p>
                  <strong
                    >Newsletters are just email, It&#39;s just email. So
                    there&#39;s a reply button. They use it, right?</strong
                  >
                </p>

                <p>RIGHT?</p>

                <p><strong>Wrong.</strong></p>

                <p>
                  Sure they can do, and some actually write back to you, but the
                  majority stays silent. That&#39;s not because they don&#39;t
                  like your writing. It&#39;s because their life is also cramped
                  with too many things. Replying to your email has no priority
                  and comes with too much friction. Even a oneliner can feel
                  like writing to the tax office...
                </p>

                <p>Nobody likes that.</p>

                <p>
                  I tried linking to an external survey form. Sure, they clicked
                  and went to the form, and then only a tiny fraction actually
                  completed it. Most didn&#39;t even answer the first question.
                  Regardless if it was multiple choice or free form.
                </p>

                <p>
                  <strong
                    >Maybe using the survey tool directly in my emails will
                    reduce friction?</strong
                  >
                </p>

                <p><strong>Nope.</strong></p>

                <p>
                  First, it created friction for me. I am using MailerLite, and
                  while I love them, they offer 3 editors for writing the
                  emails. I am using the plain one. Simple writing, simple
                  email. Just plain text.
                </p>

                <p>
                  But you can&#39;t use the survey tool here; you need to use
                  the fancy one. Now I had to fiddle with design, making it look
                  similar to my regular emails and ...
                </p>

                <p>
                  In the end, the email looked differently, and my users are not
                  used to that. Also, it&#39;s too complex to be reliable with a
                  wide range of email clients. Everyone is showing the email
                  differently.
                </p>

                <p>And the response rate stayed the same.</p>

                <p>
                  <strong
                    >Fortunately, I found a solution that works for me. Now, I
                    am getting more feedback than before—short and
                    long-form.</strong
                  >
                </p>

                <p>How?</p>

                <p>
                  <strong
                    >By using a simple 2-step process which works with plain
                    links and displays nicely in email clients.</strong
                  >
                </p>

                <p>
                  In each email, a 3-options rating system is displayed at the
                  bottom of your emails. The user can rate your email with a
                  single click on a link.
                </p>

                <p>
                  The rating is recorded by visiting that link. Followed by a
                  simple page with a sentence, the world&#39;s shortest
                  question, and a text box to write in.
                </p>

                <p>And my readers use it.</p>

                <p>
                  <strong>I got more valuable replies than ever before.</strong>
                </p>

                <p>
                  Sometimes a short sentence, other times, they aim for a short
                  story.
                </p>

                <p class="has-text-centered mt-6">
                  <a class="button is-primary is-large" href="/register">Get Started Now</a>
                </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  </div>
</template>

<script>
export default {
  name: "about",
  data: function () {
    return {

    };
  },
  methods: {
    
  },
};
</script>

